import axios from 'axios'
import moment from 'moment-timezone'

import i18n from '@/i18n'

import configuration from '@/classes/Configuration'

import store from '@/store'

const isHandlerEnabled = (config) => !(config.hasOwnProperty('enableHandler') && !config.enableHandler)

const gatewayApi = axios.create({
  baseURL: `${configuration.get('paymentGatewayApi')}/api/gateway`,
  headers: { 'Time-Zone': moment.tz.guess() }
})

// Handle errors
gatewayApi.interceptors.response.use(undefined, error => {
  if (!axios.isCancel(error)) {
    const { config, response: { status, data } } = error

    if (isHandlerEnabled(config)) {
      if (status >= 400 && status < 500) {
        data.errorReport.errors.forEach(error => {
          store.dispatch('showMessage', { title: error.translatedMessage || error.message, autoHideDelay: 5000, options: { variant: 'danger' } })
        })
      } else {
        store.dispatch('showMessage', { title: i18n.t('sentence.generalErrorMessage'), autoHideDelay: 5000, options: { variant: 'danger' } })
      }
    }

    return Promise.reject(error)
  } else {
    console.warn('Request canceled', error.message)
    return new Promise(() => {})
  }
})

export default gatewayApi
